export default __webpack_public_path__ + "static/3-387637395855ef6a9efefbdd6f1a8327.png";